import React from 'react'

import PrivateRoute from '../components/PrivateRoute/PrivateRoute'

//Reports
import Home from '../pages/Home/Home'
import Consumptions from '../pages/Consumptions/Consumptions'
import MyTeam from '../pages/MyTeam/MyTeam'
import Fleet from '../pages/Fleet/Fleet'
import DeviceReport from "../pages/LossReport/LossReport"
import Optimization from "../pages/optimization/Optimization"
import ExpensesBySite from '../pages/ExpensesBySite/ExpensesBySite'
import Ranking from '../pages/Ranking/Ranking'
import InventoryReport from '../pages/Inventory/InventoryReport/InventoryReport'
import BudgetReport from '../pages/Budget/BudgetReport'

//Profile
import Profile from '../pages/Profile/Profile'
import Password from '../pages/Password/Password'

// Billing
import ConceptConverter from '../pages/Billing/Converters/Concept'
import Concept from '../pages/Billing/Concept/Concept'
import DestinationConverter from '../pages/Billing/Converters/Destination'
import Destination from '../pages/Billing/Destination/Destination'
import ChargeGroupConcept from '../pages/Billing/ChargeGroupConcept/ChargeGroupConcept'
import ChargeGroup from '../pages/Billing/ChargeGroup/ChargeGroup'
import UploadBilling from '../pages/Billing/UploadBilling/UploadBilling'
import ChargeGroupUssage from "../pages/Billing/CharGroupUssage/ChargeGroupUssage"

// Invoicing
import WebCredentials from '../pages/Invoice/WebCredentials/WebCredentials'
import Invoice from '../pages/Invoice/Invoice/Invoice'
import AvailableInvoice from '../pages/Invoice/AvailableInvoice/AvailableInvoice'
import InvoicePayment from '../pages/Invoice/InvoicePayment/InvoicePayment'
import InvoicePaymentGroup from '../pages/Invoice/InvoicePayment/Group'
import Periods from '../pages/Invoice/Periods/Periods'
import BillingAccounts from '../pages/Billing/BillingAccount/BillingAccounts'

// Inventory
import Account from '../pages/Inventory/Account/Account'
import LegalEntity from '../pages/Inventory/LegalEntity/LegalEntity'
import User from '../pages/Inventory/User/User'
import CostCenter from '../pages/Inventory/CostCenter/CostCenter'
import Devices from '../pages/Inventory/Devices/Devices'
import GlAccount from '../pages/GlAccount/GlAccount'
import Sites from '../pages/Inventory/Sites/Sites'
import Inventory from '../pages/Inventory/Inventory/Inventory'
import ConsolidatedSBO from "../pages/consolidatedSBO/consolidatedSBO"
// Jobs
import ExcelExports from '../pages/Jobs/ExcelExports/ExcelExports'
import DataLoadTemplates from '../pages/Jobs/DataLoadTemplates/DataLoadTemplates'
import MassiveUploadControl from '../pages/Jobs/MassiveUploadControl/MassiveUploadControl'
import Process from '../pages/Jobs/Process/Process'
import CMFiles from '../pages/Jobs/companyManagement/CMFiles'
import CMSubmissions from '../pages/Jobs/companyManagement/CMSubmissions'

// Contract
import Contract from '../pages/Contract/Contract'

// Budget
import Budget from '../pages/Budget/Budget'
import BudgetPeriod from '../pages/Budget/BudgetPeriod'
import GlAccountBudgetAssociation from '../pages/Budget/Associations/GlAccountBudgetAssociation'

// Bayphone
//import { Bayphone, MyBayphone } from '../pages/Bayphone/Bayphone'
import Bayphone from '../pages/Bayphone/Bayphone'
import MyBayphone from '../pages/Bayphone/MyBayphone'
import BayphoneUser from '../pages/Bayphone/BayphoneUser'
import BayphoneDashBoard from '../pages/Bayphone/Dashboard/BayphoneDashBoard'

import GetApolloClient from '../utils/getApolloClient'
import { topLevelRoutes } from './routeRegistry'

// Maps each path to its component. Routes with special render needs (e.g. those
// requiring a client prop) use SPECIAL_RENDERS instead.
const COMPONENTS = {
    '/':                         Home,
    '/consumptions':             Consumptions,
    '/myTeam/':                  MyTeam,
    '/fleetMetrics':             Fleet,
    '/lossreport':               DeviceReport,
    '/consolidatedSBO/':         ConsolidatedSBO,
    '/optimization/':            Optimization,
    '/expensesBySite/':          ExpensesBySite,
    '/ranking/':                 Ranking,
    '/inventoryReport/':         InventoryReport,
    '/budgetReport/':            BudgetReport,
    '/profile':                  Profile,
    '/password':                 Password,
    '/converters/concept':       ConceptConverter,
    '/concept':                  Concept,
    '/converters/destination':   DestinationConverter,
    '/destination':              Destination,
    '/chargeGroupConcept':       ChargeGroupConcept,
    '/chargeGroup':              ChargeGroup,
    '/chargeGroupUssage':        ChargeGroupUssage,
    '/webcredentials':           WebCredentials,
    '/invoice':                  Invoice,
    '/availableInvoice':         AvailableInvoice,
    '/invoicePayment':           InvoicePayment,
    '/apgl':                     InvoicePaymentGroup,
    '/periods':                  Periods,
    '/billingAccounts':          BillingAccounts,
    '/account':                  Account,
    '/legalEntity':              LegalEntity,
    '/user':                     User,
    '/costCenter':               CostCenter,
    '/devices':                  Devices,
    '/sites':                    Sites,
    '/inventory':                Inventory,
    '/excelExports':             ExcelExports,
    '/dataLoadTemplates':        DataLoadTemplates,
    '/massiveUploadControl':     MassiveUploadControl,
    '/processControl':           Process,
    '/companyManagementFiles':   CMFiles,
    '/companyManagementSubmissions': CMSubmissions,
    '/contract':                 Contract,
    '/glAccount':                GlAccount,
    '/budget':                   Budget,
    '/budgetPeriod/:budgetId':   BudgetPeriod,
    '/budgetsAssociations':      GlAccountBudgetAssociation,
    '/bayphone':                 Bayphone,
    '/bayphoneUser':             BayphoneUser,
    '/bayphoneDashBoard':        BayphoneDashBoard,
    '/myBayphones':              MyBayphone,
};

// Routes whose render can't be expressed as a plain component prop.
const SPECIAL_RENDERS = {
    '/backoffice/upload_billing': () => (
        <GetApolloClient>
            {client => <UploadBilling client={client} />}
        </GetApolloClient>
    ),
};

export default (
    <>
        {topLevelRoutes.map(({ path, exact }) => {
            const renderFn = SPECIAL_RENDERS[path];
            if (renderFn) {
                return (
                    <PrivateRoute key={path} path={path} exact={exact || false}>
                        {renderFn()}
                    </PrivateRoute>
                );
            }
            return (
                <PrivateRoute
                    key={path}
                    path={path}
                    exact={exact || false}
                    component={COMPONENTS[path]}
                />
            );
        })}
    </>
);
